<template>
  <div>
    <form>
      <!-- <pre>{{eachEventInfo}}</pre> -->
      <!-- <input type="color" v-model="color" /> -->
      <strong class="block">Schedule Start : {{start_time}}</strong>
            <strong class="block"> Schedule End : {{end_time}}</strong>

     <!-- {{end_time}} -->
      <label class="vs-input--label">Select your color code</label>
<!-- {{availabilityTime}} -->
     
      
      <div class="cstmColorHolder mt-0">
        <div class="flex flex-wrap">
          <div
            class="cstmColorDiv"
            @click="selectColor(index)"
            :class="{ active: activeIndex === index }"
            :style="{ backgroundColor: presetColor }"
            v-for="(presetColor, index) in presetColors"
            :key="index"
          ></div>
        </div>
        <div class="moreColor">
          <input
            v-model="color"
            type="color"
            v-validate="'required'"
            data-vv-name="textColor"
          />
          <a>More Colors</a>
        </div>
      </div>
            <label class="vs-input--label">Please select updated date:</label>

      <flat-pickr
                  v-model="updated_date"
                  :config="configDate"
                ></flat-pickr>
   
      <div class="flex flex-wrap">
        <div class="time_zone_holder lg:w-2/3 md:w-full w-full p-4">
          <strong class="block mb-2">Available Time Slot</strong>

          <!-- {{timeSlot}} -->
          <vs-radio class="mr-2 mb-2" 
          v-for="(eachtime, index) in availabilityTime"
          :key="index"
          v-model="timeSlot"
          vs-name="timezone"
          :vs-value="eachtime.start_time+'-'+eachtime.end_time">
            <div class="bg-grey">
              {{ eachtime.start_time +'-'+ eachtime.end_time }}
            </div>
          </vs-radio>
          <p v-if="availabilityTime.length == 0" style="opacity: 0.7;">No dates selected yet</p>
        </div>
        <div class="lg:w-1/3 md:w-1/2 w-full p-4">
          <strong class="block">Rescheduled Log</strong>
          <div class="scheduled_log_holder">
            <div class="time_zone_log" v-for="(eachSchedule, index) in scheduleLog" :key="index">
              <span>({{eachSchedule.changed_from_date}}){{ eachSchedule.changed_from_time }}-{{eachSchedule.changed_to_time}}</span>
            </div>
            <p v-if="scheduleLog.length == 0" style="opacity: 0.7;">No data log</p>
          </div>
        </div>
      </div>

      <div class="text-right mt-4">
        <vs-button class="mr-2" type="border" color="danger"
        @click="$emit('cancelEditingComponent')"
        >Cancel</vs-button>
        <vs-button
        v-if="timeSlot && updated_date && name === 'Teachers'"
        @click.prevent="updateReshedule()"
        >Reschedule</vs-button>
         <vs-button
        v-if="timeSlot && updated_date  && name === 'cancel'"
        @click.prevent="updateCancelReshedule()"
        >Reschedule</vs-button>
      </div>
    </form>
  </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import {updateRescheduleApi, getShedulerLogApi, getTeacherAvailabilityApi, cancelRescheduleUpdateApi,getAvailableDay} from '@/api/schedulerApi'

export default {
  components: {
    flatPickr
  },
  props:{
    schedule_date:{},
    start_time:{},
    end_time:{},
    userId:{},
    color_code:{},
    course_id:{},
    schedule_id:{},
    client_user_id:{},
    name:{},
    eachEventInfo:{}
  },
  mounted () {
    this.schedule_from_time = this.start_time
    this.schedule_end_time = this.end_time
    this.color = this.color_code
    this.getSchedule()
    this.fetchAvailableDay()
  },
  watch:{
    updated_date () {
      console.log('hi')
      console.log(this.updated_date)
      this.timeSlot = ''
      this.getTeacherAvailabilityTime()
    }
  },
  methods:{
       async fetchAvailableDay(){
      try{
         const payload = {
        customer_id:localStorage.getItem('customer_id'),
        user_id:this.userId,
        course_id:this.course_id
      }
      const {data} = await getAvailableDay(payload)
      this.available_days= data.data.available_days
      console.log(data.data)
      this.available_days = this.available_days.map(day =>{
        return day = day.substring(0,3)
      })
      console.log(this.available_days)
      this.configDate.enable=[(date)=> {
          const day = date.toDateString().split(" ")
          return this.available_days.includes(day[0])
        }]
      } catch(e){
        console.log(e)
      }
     
    },
    async getSchedule () {

      console.log('hi reschedule')

      try {
        const payload = {
          schedule_id:this.schedule_id,
          course_id:this.course_id
        }
        const customer_id = localStorage.getItem('customer_id')
        console.log(payload)
        const {data} = await getShedulerLogApi(customer_id, payload)
        this.scheduleLog = data.data.log
        console.log(this.scheduleLog)
        console.log(data)

        // console.log(data)

      } catch (err) {
        console.warn(err)
      }
    },
 
    async getTeacherAvailabilityTime () {
      try {
        const customer_id = localStorage.getItem('customer_id')

        const payload = {
          schedule_date:this.$moment(this.updated_date).format('YYYY-MM-DD'),
          teacher_id:this.userId,
          course_id:this.course_id
        }
        const {data} = await getTeacherAvailabilityApi(customer_id, payload)
        console.log(data.data)
        this.availabilityTime = data.data.availability
        if (!this.availabilityTime.length) {
          this.showSuccessMessage('Error', 'No Availability Found', 'danger')
        }
        console.log(data)
      } catch (error) {
        console.warn(error)
      }
    },
    checkTime () {
      return parseInt(this.schedule_from_time.replace(':', '')) < parseInt(this.schedule_end_time.replace(':', ''))
    },
    updateReshedule () {

      // const hasTrue = this.checkTime()
    
      //   const userInfo = JSON.parse(localStorage.getItem('userInfo'))

      if (this.updated_date && this.timeSlot) {

        const [schedule_from_time, schedule_end_time] = this.timeSlot.split('-')
      
        console.log(schedule_end_time)
        console.log(schedule_from_time)
        const payload = {
          changed_from_time:schedule_from_time,
          changed_to_time:schedule_end_time,
          schedule_from_time:this.start_time,
          schedule_to_time:this.end_time,
          colour_code:this.color,
          user_id:this.userId,
          schedule_id:this.schedule_id,
          changed_from_date:this.updated_date,
          schedule_date:this.$moment(this.schedule_date).format('YYYY-MM-DD'),
          client_user_id:this.client_user_id,
          group_id:this.eachEventInfo.extendedProps.course.group_id
        }

        console.log(payload)
        
        this.updateRescheduling(payload)
      } else {
        this.showSuccessMessage('Error', 'Must Select Updated Date And timeslot', 'danger')
      }
      //   
      
      
    },
    async updateRescheduling (payload) {
      try {
        
        const customer_id = localStorage.getItem('customer_id')
        await updateRescheduleApi(this.course_id, customer_id, payload)
        this.showSuccessMessage('Schedule', 'Schedule Updated Successfully', 'success')

        this.$emit('updateReschedule', payload)
        
      } catch (error) {
        console.warn(error)
      }
    },
    updateCancelReshedule () {
      if (this.updated_date && this.timeSlot) {

        const [schedule_from_time, schedule_end_time] = this.timeSlot.split('-')
      
        console.log(schedule_end_time)
        console.log(schedule_from_time)
        const payload = {
          course_id:this.course_id,
          schedule_from_time,
          schedule_to_time:schedule_end_time,
          all_day_event:this.eachEventInfo.extendedProps.course.all_day_event,
          colour_code:this.color,
          teacher_id:this.userId,
          schedule_id:this.schedule_id,
          schedule_date:this.updated_date,
          client_user_id:this.client_user_id,
          skype_link:this.eachEventInfo.extendedProps.course.skype_link,
          zoom_link:this.eachEventInfo.extendedProps.course.zoom_link,
          description:this.eachEventInfo.extendedProps.course.description,
          custom:0,
          group_id:this.eachEventInfo.extendedProps.course.group_id
        }


        console.log(payload)
        
        this.updateCancelRescheduling(payload)
      } else {
        this.showSuccessMessage('Error', 'Must Select Updated Date And timeslot', 'danger')
      }

    },
    async updateCancelRescheduling (payload) {
      try {
        
        const customer_id = localStorage.getItem('customer_id')
        await cancelRescheduleUpdateApi(customer_id, payload)
        this.showSuccessMessage('Schedule', 'Schedule Updated Successfully', 'success')

        this.$emit('updateReschedule', payload)
        
      } catch (error) {
        console.warn(error)
      }
    },
    selectColor (index) {
      // alert(this.presetColors[index])
      this.color = this.presetColors[index]
      this.activeIndex = index
      // alert(this.eventTextColor)
    }
  },
  data () {
    return {
      available_days:[],
      configDate:{
        minDate: new Date(),
        enable:[]
      },
      config: {
        enableTime: true,
        noCalendar: true,
        dateFormat: 'H:i'
      },
      updated_date:'',
      configTime: {
        enableTime: true,
        noCalendar: true,
        time_24hr: true,
        dateFormat: 'H:i',
        wrap: true
      },
      activeIndex:null,
      color: '#f40606',
      schedule_from_time: '',
      schedule_end_time: '',
      user_id:10,
      presetColors: [
        '#d50000',
        '#f4511e',
        '#e67c73',
        '#f6bf26',
        '#3f51b5',
        '#0b8043'
      ],
      timeSlot: '',
      availabilityTime:[],
      timeZone: [
        {
          time: '09:30 - 10:00'
        },
        {
          time: '10:00 - 10:30'
        },
        {
          time: '10:30 - 11:00'
        },
        {
          time: '11:00 - 11:30'
        },
        {
          time: '11:30 - 12:00'
        },
        {
          time: '12:00 - 12:30'
        }
      ],
      scheduleLog:[]
    }
  }
}
</script>